import React, { useState } from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { useProjectState } from "../../../context/stateContext";
import AreasInfoModal from "./AreasInfoModal";

export const getTotalSum = (areasTurnOver) => {
  let dataProductsTotalSum = 0;
  if (areasTurnOver.length === 0) return 0.0;
  else {
    areasTurnOver.forEach((element) => {
      dataProductsTotalSum += element.total;
    });
    return dataProductsTotalSum;
  }
};

const AreasInfoTable = () => {
  const [selectedRowData, setSelectedRowData] = useState({});

  const { setShowAreaSalesDetails, showPaymentMethods } = useProjectState();
  const { areasTurnOver, loading } = useSelector((state) => state.areasReducer);

  const newArray = new Map();

  areasTurnOver.forEach((obj) => {
    const { id, total, card, cash, other } = obj;
    if (newArray.has(id)) {
      const existingData = newArray.get(id);
      existingData.total += total;
      existingData.card += card;
      existingData.cash += cash;
      existingData.other += other;
    } else {
      newArray.set(id, {
        total,
        card,
        cash,
        other,
      });
    }
  });

  const data = Array.from(newArray, ([id, values]) => ({
    id,
    ...values,
    name: areasTurnOver.find((obj) => obj.id === id).name,
    date: areasTurnOver.find((obj) => obj.id === id).date,
  }));
  data.sort((a, b) => a.name.localeCompare(b.name));

  const columns = [
    {
      title: "Обект",
      dataIndex: "name",
      rowKey: "name",
      width: "20%",
      sorter: (a, b) => a.name.localeCompare(b.name),
      key: "name",
      render: (name) => <span className="areas-info-table-text">{name}</span>,
    },
    {
      title: () => {
        return (
          <div style={{ whiteSpace: "nowrap" }}>
            Оборот{" "}
            {getTotalSum(areasTurnOver)
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      dataIndex: "total",
      rowKey: "total",
      width: "20%",
      sorter: (a, b) => a.total - b.total,
      align: "right",
      key: "total",

      render: (total) => (
        <span className="areas-info-table-text">{total.toFixed(2)}</span>
      ),
    },
  ];

  if (showPaymentMethods) {
    columns.splice(1, 0, {
      title: "Други",
      dataIndex: "other",
      rowKey: "other",
      width: "20%",
      sorter: (a, b) => a.other - b.other,
      align: "center",
      key: "other",

      render: (other) => (
        <span className="waiters-info-table-text">{other.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: "Карта",
      dataIndex: "card",
      rowKey: "card",
      width: "20%",
      sorter: (a, b) => a.card - b.card,
      align: "center",
      key: "card",

      render: (card) => (
        <span className="waiters-info-table-text">{card.toFixed(2)}</span>
      ),
    });
    columns.splice(1, 0, {
      title: "Брой",
      dataIndex: "cash",
      rowKey: "cash",
      width: "20%",
      sorter: (a, b) => a.cash - b.cash,
      align: "center",
      key: "cash",

      render: (cash) => (
        <span className="waiters-info-table-text">{cash.toFixed(2)}</span>
      ),
    });
  }

  return (
    <>
      <div className="areas-info-table-container">
        <Table
          loading={loading}
          rowKey="id"
          showHeader
          dataSource={data}
          columns={columns}
          pagination={false}
          className="areas-info-table"
          onRow={(record) => {
            return {
              onClick: () => {
                setSelectedRowData(
                  areasTurnOver.filter((data) => data.id === record.id)
                );
                setShowAreaSalesDetails(true);
              },
            };
          }}
        />
      </div>
      {Object.keys(selectedRowData).length !== 0 && (
        <AreasInfoModal row={selectedRowData} />
      )}
    </>
  );
};

export default AreasInfoTable;
